export default class y {
  constructor() {}
  Rs(a) {}
  changeUser(a = !1) {}
  clearData(a = !1) {}
}
